const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyAxMUgyMlYxM0gxM1YyMkgxMVYxM0gyVjExSDExVjJIMTNWMTFaIi8+Cjwvc3ZnPgo=";
export {
  M as default
};
//# sourceMappingURL=plus-304556f6.mjs.map
